/**
 * Utilidades para el inicio de sesión con proveedores externos (Google / Apple).
 *
 * El flujo guarda un "state" temporal en el navegador y lo verifica al volver.
 * Si la vuelta ocurre en otro dominio (ticomarket.com vs www.ticomarket.com)
 * o en otro navegador (webview de Instagram/Facebook), la verificación falla
 * con "State verification failed".
 */

export const OAUTH_DEST_KEY = "tm_oauth_destination";
const CANONICAL_HOST = "www.ticomarket.com";
const APEX_HOST = "ticomarket.com";

/** Detecta navegadores internos de redes sociales, donde el login externo suele fallar. */
export function isSocialWebView(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /FBAN|FBAV|FB_IAB|Instagram|Line\/|Twitter|TikTok/i.test(ua);
}

/**
 * Si estamos en el dominio sin "www", movemos a la versión canónica antes de
 * arrancar el login, para que la ida y la vuelta ocurran en el mismo origen.
 * Devuelve true si se disparó una redirección (el caller debe detenerse).
 */
export function ensureCanonicalHost(): boolean {
  if (typeof window === "undefined") return false;
  if (window.location.hostname !== APEX_HOST) return false;
  const url = new URL(window.location.href);
  url.hostname = CANONICAL_HOST;
  window.location.replace(url.toString());
  return true;
}

/** Guarda el destino interno al que hay que llevar a la persona tras autenticarse. */
export function saveOAuthDestination(path: string) {
  try {
    const safe = path.startsWith("/") && !path.startsWith("//") ? path : "/";
    sessionStorage.setItem(OAUTH_DEST_KEY, safe);
    localStorage.setItem(OAUTH_DEST_KEY, safe);
  } catch {
    /* almacenamiento no disponible */
  }
}

/** Lee y limpia el destino guardado. */
export function takeOAuthDestination(): string {
  let dest = "/";
  try {
    dest =
      sessionStorage.getItem(OAUTH_DEST_KEY) ||
      localStorage.getItem(OAUTH_DEST_KEY) ||
      "/";
    sessionStorage.removeItem(OAUTH_DEST_KEY);
    localStorage.removeItem(OAUTH_DEST_KEY);
  } catch {
    /* almacenamiento no disponible */
  }
  return dest.startsWith("/") && !dest.startsWith("//") ? dest : "/";
}
